import React, { Component } from 'react'
import './styles.sass'

import MountComponentOnBody from "../mount-component-on-body";

// A basic modal component that takes content as props.children
class SimpleModal extends Component {

  constructor(props) {
    super(props);
    this.props = props;
  }

   componentWillUnmount = () => {
      // Remove 'modal-open' class from the body when this component is destroyed
      if (document.body.classList.contains('modal-open')) {
         document.body.classList.remove('modal-open')
      }
      document.removeEventListener('keyup', this.handleDocKeyUp, false);
   };

  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.isOpen) {
      if (!prevProps.isOpen) {
        this.scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        document.addEventListener('keyup', this.handleDocKeyUp, false);
      }
    } else {
      document.body.classList.remove('modal-open');
      // window.scrollTo(0, this.scrollTop);
    }
  };

  render() {
    if (!this.props.isOpen) {
      return null;
    }
    document.body.classList.add('modal-open');

    let cssClass = "simple-modal";
        cssClass += this.props.modalClassName ? ` ${this.props.modalClassName}` : '';
        cssClass += this.props.centered ? ' centered' : '';
    return (
      <MountComponentOnBody {...this.props} componentId={this.props.modalId || 'root-simple-modal'}>
        <div className={cssClass} onMouseDown={this.handleOutsideClick}>
          <div className="outer" onMouseDown={this.handleOutsideClick}>
            <div
              className="inner"
              onClick={this.handleInsideClick}
              style={this.props.inlineInnerStyle}
            >
              {this.props.children}
              { !this.props.hideCloseButton &&
                <a className="close-modal" onClick={this.props.onCloseClick}>&times;</a>
              }
            </div>
          </div>
        </div>
      </MountComponentOnBody>
    );
  };

  handleOutsideClick = (e) => {
    /* This is a mouseDown event because of mentions. Clicking inside but
       releasing *outside* of a contentEditable will result in the outside click
       being fired. So things like click > drag to select text breaks since the
       modal closes if the mouse is released outside the modal content.

       To remedy, we use a mouseDown event and ensure that the target is the
       outer element before triggering a close */
    if (e.target.className === "outer") {
      this.props.onCloseClick(e);
      e.stopPropagation();
    }
  };

  handleInsideClick = (e) => {
    e.stopPropagation();
  };

  handleDocKeyUp = (e) => {
    if (e.keyCode === 27) {
      // Close modal on esc keyup
      this.props.onCloseClick(e);
    }
  }

};

export default SimpleModal;



// WEBPACK FOOTER //
// ./assets/es6/common/components/SimpleModal/index.es6